const config = {
   
    razorpayKey:"rzp_test_Vs8C4KZWPpCkFv",
    baseurl :"https://uattotsapi.fcintelli.tech/api/"
    
    };
    module.exports = config;
    